import styled from 'styled-components';

import { Text } from '@gympass/yoga';

import { Button } from 'components';

import * as EndUserStyles from '../EndUser/styles';

export const Container = styled.main`
  background-color: ${({ theme }) => theme.yoga.colors.backgroundLight};
  min-height: 100vh;
  height: 100%;
  margin: ${({ theme }) => theme.yoga.spacing.zero} auto;
`;

export const HeaderInfoContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  padding: ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const HeaderLabel = styled(Text.H4)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.light};
  line-height: ${({ theme }) =>
    theme.yoga.lineHeights.sessionHistoryTitleLineHeight}px;
`;

export const Divisor = styled(EndUserStyles.Divisor)``;

export const DataContainer = styled.div`
  padding: ${({ theme }) => theme.yoga.spacing.large}px
    ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const DataCard = styled.div`
  display: flex;
  padding: ${({ theme }) => theme.yoga.spacing.large}px;
  background-color: ${({ theme }) => theme.yoga.colors.white};
  min-height: ${({ theme }) => theme.yoga.sizes.sessionHistoryDataCardHeight}px;
  border-radius: ${({ theme }) => theme.yoga.radii.small}px;
  width: 100%;
  box-shadow: ${({ theme }) => theme.yoga.elevations.medium};
`;

export const AdjustLink = styled(props => <Button {...props} />)`
  margin-top: ${({ theme }) => theme.yoga.spacing.small}px;
`;

export const AdjustWarning = styled(Text.Tiny)`
  color: ${({ theme }) => theme.yoga.colors.deep};
  margin-top: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
`;

export const PaginatorContainer = styled.div`
  width: 100%;
  margin-top: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SessionsTablecontainer = styled.div`
  flex: 1;
`;

export const BigNumbersContainer = styled.div`
  height: 100%;
  width: ${({ theme }) => theme.yoga.sizes.bigNumberContainerWidth}px;
  margin-right: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
`;

export const SubHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${({ theme }) => theme.yoga.spacing.zero}
    ${({ theme }) => theme.yoga.spacing.large}px;
`;

export const DatePaginationContainer = styled.div`
  display: flex;
  align-items: center;
`;
